import { render } from "./FirstStep.vue?vue&type=template&id=5d36ec2e&scoped=true"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"

import "./FirstStep.vue?vue&type=style&index=0&id=5d36ec2e&scoped=true&lang=css"

import exportComponent from "/Users/dawndo/bestphone/main_apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d36ec2e"]])

export default __exports__